import { API } from './api';


export const getCensusTracts = async () => {
    const response = await API.get('/overlays/tracts');
    return response.json();

}


export const getTractsByOverlayId = async (overlayId, params = {}) => {
    let endpoint = `/overlays/${overlayId}`;

    // Map censusTracts → /overlays/tracts
    if (overlayId === 'censusTracts') {
        endpoint = '/overlays/tracts';
    }

    // Add query parameters (only if provided)
    const query = new URLSearchParams(params).toString();
    if (query) {
        endpoint += `?${query}`;
    }

    const response = await API.get(endpoint);
    console.log(response);
    return response.data;
};


export const getComprehensiveTractData = async (params = {}) => {
    const response = await API.get('/overlays/comprehensive', { params });
    return response.data.data;
}